// src/pages/durgapuja/DurgaPujaHome.jsx
import React from 'react';

const DurgaPujaHome = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>DurgaPuja Home</h1>
      <p>This is a placeholder page for the DurgaPuja (Hindu Religion Festival) module.</p>
    </div>
  );
};

export default DurgaPujaHome;